import React, { Component } from "react";
import {
  GET,
  GET_FILE,
  loading,
  NavbarCustomer,
  t // นำเข้าฟังก์ชันแปลภาษา
} from "../../components/CustomComponent.js";
import { getProfile } from "../../utils/localStorage";
import { isStaffViewingCustomerPortal, getSelectedCustomerUid } from "../../utils/customerScope";

// สีของ badge ตามสถานะใบสั่งงาน - ใช้ชุดเดียวกับหน้าใบแจ้งงานของลูกค้า
const STATUS_COLOR = {
  draft: "secondary",
  open: "primary",
  assigned: "primary",
  scheduled: "primary",
  in_progress: "warning",
  // สถานะชุดใหม่ (WO in_progress -> check_in, visit check_out = เสร็จหน้างาน)
  check_in: "warning",
  check_out: "warning",
  pending: "warning",
  pending_approve: "warning",
  completed: "success",
  success: "success",
  rejected: "danger",
  cancel: "danger",
  cancelled: "danger",
};

// ไอคอนของการ์ดงาน - เดาจากชื่องาน เพราะ backend ไม่ได้เก็บไอคอนไว้ (แนวเดียวกับหน้า My Assets)
const statusColor = (status) => STATUS_COLOR[(status || "").toLowerCase()] || "secondary";

const statusLabel = (status) => (status || "-").replaceAll("_", " ").toUpperCase();

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

const formatTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
};

const formatTimeRange = (start, end) => [formatTime(start), formatTime(end)].filter(Boolean).join(" - ");

const dayOfMonth = (dateStr) => {
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? "-" : String(date.getDate());
};

const monthShort = (dateStr) => {
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-US", { month: "short" }).toLowerCase();
};

// ตัวย่อชื่อช่างสำหรับวงกลม avatar
const initials = (name) => {
  if (!name) return "--";
  const parts = name.trim().split(/\s+/);
  return (parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0].slice(0, 2)).toUpperCase();
};

// ทักทายตามช่วงเวลาจริงของเครื่องผู้ใช้ (เดิม hardcode เป็น "สวัสดีตอนเช้า" ตลอด)
const greetingKey = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "greeting_morning";
  if (hour < 18) return "greeting_afternoon";
  return "greeting_evening";
};

const todayText = () =>
  new Date().toLocaleDateString(localStorage.getItem("lang") === "EN" ? "en-GB" : "th-TH", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export default class CustomerDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer: null,

      stats: {
        open_requests: 0,
        in_progress: 0,
        scheduled_visits: 0,
        total_assets: 0
      },

      active_jobs: [],
      upcoming_visits: [],
      recent_reports: [],
      warranty_alert: { count: 0, window_days: 0, assets: [] },

      loaded: false
    };
  }

  async componentDidMount() {
    // พนักงานภายในที่ยังไม่ได้เลือกลูกค้า -> navbar จะเด้ง modal ให้เลือกก่อน ยังไม่ต้องยิง API
    if (isStaffViewingCustomerPortal(getProfile()) && !getSelectedCustomerUid()) {
      loading(false);
      return;
    }

    await this.Get();
    loading(false);
  }

  Get = async () => {
    loading(true);

    const result = await GET("customer/dashboard");

    if (result?.status === true) {
      const data = result.data || {};
      this.setState({
        customer: data.customer || null,
        stats: data.stats || this.state.stats,
        active_jobs: Array.isArray(data.active_jobs) ? data.active_jobs : [],
        upcoming_visits: Array.isArray(data.upcoming_visits) ? data.upcoming_visits : [],
        recent_reports: Array.isArray(data.recent_reports) ? data.recent_reports : [],
        warranty_alert: data.warranty_alert || this.state.warranty_alert,
        loaded: true
      });
    }

    loading(false);
  };

  // ไฟล์ PDF ที่ backend เรนเดอร์เอง (ตัวเดียวกับที่เว็บแอดมิน/มือถือโหลด)
  downloadServiceReport = async (report) => {
    if (!report?.wo_uid || !report?.visit_uid) return;

    loading(true);

    const result = await GET_FILE(`customer/work-orders/${report.wo_uid}/visits/${report.visit_uid}/service-report/pdf`);

    if (result?.status === true) {
      const url = window.URL.createObjectURL(result.blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = result.fileName || "service-report.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }

    loading(false);
  };

  // วัน-เวลาที่นัดของการเข้าพื้นที่ครั้งนั้น เช่น "07/09/2569, 09:00 - 17:00"
  jobDetailText = (job) => {
    if (!job.start_date) return t("not_scheduled");
    const timeRange = [formatTime(job.start_date), job.end_date ? formatTime(job.end_date) : null]
      .filter(Boolean)
      .join(" - ");
    return [formatDate(job.start_date), timeRange].filter(Boolean).join(", ");
  };

  // ตัวย่อชื่อช่างสำหรับวงกลมมุมขวาล่างของการ์ด (2 ตัวแรกของชื่อ ตัดช่องว่างออก)
  technicianInitials = (name) => {
    const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2);
    return `${parts[0][0]}${parts[1][0]}`;
  };

  warrantyMessage = () => {
    const { warranty_alert } = this.state;
    return t("warranty_alert_summary")
      .replace("{count}", warranty_alert.count)
      .replace("{days}", warranty_alert.window_days);
  };

  render() {
    const { customer, stats, active_jobs, upcoming_visits, recent_reports, warranty_alert, loaded } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />

        <div className="body p-4 mt-3">
          {/* Header Banner Section */}
          <div className="bg-success text-white p-4 rounded-4 shadow-sm mb-4 d-flex justify-content-between align-items-center" style={{ background: "linear-gradient(90deg, #198754 0%, #20c997 100%)" }}>
            <div>
              <h3 className="fw-bold mb-1">{t(greetingKey())}, {customer?.name || "-"}</h3>
              <div className="text-white text-opacity-75">{todayText()}</div>
            </div>
            <button
              className="btn btn-light fw-bold px-4 py-2 rounded-3 shadow-sm border-0 text-success d-flex align-items-center"
              onClick={() => { window.location.href = "/cs/work-requests/create"; }}
            >
              <span className="me-2 text-20">+</span> {t("create_service_request")}
            </button>
          </div>

          {/* Top KPI Stats */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("open_requests")}</div>
                    <h2 className="fw-bold mb-0 mt-1">{stats.open_requests}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf15b"}</div>
                </div>
              </div>
            </div>
            {/* ... ตัวอย่าง KPI อื่นๆ ใช้โครงสร้างเดียวกัน ... */}
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("in_progress")}</div>
                    <h2 className="fw-bold text-warning mb-0 mt-1">{stats.in_progress}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf0ad"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("scheduled_visits")}</div>
                    <h2 className="fw-bold text-success mb-0 mt-1">{stats.scheduled_visits}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf073"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("total_assets")}</div>
                    <h2 className="fw-bold mb-0 mt-1">{stats.total_assets}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf1b3"}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-lg-8">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf0ca"}</span> {t("active_jobs")}</h5>
                <a href="/cs/appointments" className="text-decoration-none text-14 fw-bold">{t("view_all")}</a>
              </div>

              <div className="d-flex flex-column gap-3 mb-5">
                {active_jobs.length === 0 ? (
                  <div className="card border-0 rounded-4 shadow-sm p-4 bg-white text-center text-secondary">
                    {loaded ? t("no_active_jobs") : t("loading")}
                  </div>
                ) : active_jobs.map((job, idx) => {
                  const color = statusColor(job.status);
                  const priorityBg = job.priority?.background_color || "#FEF3C7";
                  const priorityColor = job.priority?.font_color || "#92400E";
                  return (
                    <div key={job.uid || idx} className="card border-0 rounded-4 shadow-sm p-3 bg-white transition-hover">
                      {/* หัวการ์ด: เลขใบงาน + ระดับความสำคัญ */}
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <span className="fw-bold text-primary text-14">{job.wo_number || "-"}</span>
                        {job.priority?.label ? (
                          <span
                            className="badge rounded-pill px-3 py-1 fw-bold text-10"
                            style={{ backgroundColor: priorityBg, color: priorityColor }}
                          >
                            {job.priority.label}
                          </span>
                        ) : (
                          <span className={`badge bg-${color}-light text-${color} rounded-pill px-3 py-1 fw-bold text-10`}>
                            {statusLabel(job.status)}
                          </span>
                        )}
                      </div>

                      {/* ครั้งที่เข้าพื้นที่ของใบงานนี้ */}
                      <div className="mb-2">
                        <span className="badge rounded-pill px-3 py-1 fw-bold text-10" style={{ backgroundColor: "#EFF6FF", color: "#2563EB" }}>
                          {t("visit_label")} {job.sequence || 1}/{job.total_visits || 1}
                        </span>
                      </div>

                      <h6 className="fw-bold text-dark mb-1">{job.title || "-"}</h6>
                      <div className="text-secondary text-13 mb-1">{job.contact_name || job.asset_name || "-"}</div>
                      {job.asset_name && job.contact_name && (
                        <div className="text-secondary text-12 mb-1">{[job.asset_name, job.asset_location].filter(Boolean).join(" · ")}</div>
                      )}

                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-secondary text-12">
                          <span className="icon me-1">{"\uf133"}</span> {this.jobDetailText(job)}
                        </div>
                        {/* ช่างที่รับผิดชอบครั้งนี้ - ยังไม่มอบหมายก็บอกให้ชัด */}
                        {job.technician_names?.length ? (
                          <div className="d-flex align-items-center">
                            {job.technician_names.slice(0, 3).map((name, i) => (
                              <span
                                key={`${name}-${i}`}
                                title={name}
                                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white fw-bold"
                                style={{ width: 28, height: 28, fontSize: 11, marginLeft: i ? -8 : 0, border: "2px solid #fff" }}
                              >
                                {this.technicianInitials(name)}
                              </span>
                            ))}
                            {job.technician_names.length > 3 && (
                              <span className="text-secondary text-12 ms-2">+{job.technician_names.length - 3}</span>
                            )}
                          </div>
                        ) : (
                          <span className="text-secondary text-12">{t("unassigned_technician")}</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf15c"}</span> {t("recent_service_reports")}</h5>
                <a href="/cs/service-history" className="text-decoration-none text-14 fw-bold">{t("view_all")}</a>
              </div>
              <div className="card border-0 rounded-4 shadow-sm bg-white overflow-hidden">
                {recent_reports.length === 0 ? (
                  <div className="p-4 text-center text-secondary">{loaded ? t("no_recent_reports") : t("loading")}</div>
                ) : recent_reports.map((report, idx) => (
                  <div key={report.visit_uid || idx} className={`p-3 d-flex justify-content-between align-items-center ${idx !== recent_reports.length - 1 ? 'border-bottom' : ''}`}>
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf1c1"}</div>
                      <div>
                        <h6 className="fw-bold text-dark mb-0">{[report.wo_number, report.title].filter(Boolean).join(" - ")}</h6>
                        <div className="text-secondary text-12">{t("completed")}: {formatDate(report.completed_at) || "-"}</div>
                      </div>
                    </div>
                    <button
                      className="btn btn-outline-secondary btn-sm px-3 rounded-2 text-dark border-light fw-bold bg-white d-flex align-items-center shadow-sm"
                      onClick={() => this.downloadServiceReport(report)}
                    >
                      <span className="icon me-2">{"\uf019"}</span> {t("download")}
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-4">
              <h5 className="fw-bold mb-3 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf073"}</span> {t("upcoming_visits")}</h5>
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white mb-4">
                <div className="d-flex flex-column gap-4">
                  {upcoming_visits.length === 0 ? (
                    <div className="text-center text-secondary">{loaded ? t("no_upcoming_visits") : t("loading")}</div>
                  ) : upcoming_visits.map((visit, idx) => (
                    <div key={visit.uid || idx} className="d-flex">
                      <div className="text-center me-3">
                        <div className="bg-success text-white rounded-3 overflow-hidden shadow-sm" style={{ width: '45px' }}>
                          <div className="text-10 py-1" style={{ backgroundColor: '#157347' }}>{t(monthShort(visit.start_date))}</div>
                          <div className="fw-bold py-1 bg-success-light text-success">{dayOfMonth(visit.start_date)}</div>
                        </div>
                      </div>
                      <div>
                        <h6 className="fw-bold text-dark mb-1">{visit.title || "-"}</h6>
                        <div className="text-secondary text-12 mb-2">{formatTimeRange(visit.start_date, visit.end_date) || formatDate(visit.start_date)}</div>
                        <div className="d-flex align-items-center">
                          <div className="wpx-20 hpx-20 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center text-8 fw-bold me-2">{initials(visit.technician_name)}</div>
                          <div className="text-secondary text-12">{visit.technician_name || t("unassigned_technician")}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <hr className="my-4 text-light" />
                <div className="text-center">
                  <a href="/cs/appointments" className="text-decoration-none text-14 fw-bold">{t("view_full_calendar")}</a>
                </div>
              </div>

              <h5 className="fw-bold mb-3 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf0e7"}</span> {t("quick_actions")}</h5>
              <div className="d-flex flex-column gap-2 mb-4">
                <button
                  className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover"
                  onClick={() => { window.location.href = "/cs/work-requests/create"; }}
                >
                  <div className="wpx-35 hpx-35 rounded bg-success-light text-success d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf067"}</div>
                  <span className="fw-bold text-dark text-14">{t("new_service_request")}</span>
                </button>
                <button
                  className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover"
                  onClick={() => { window.location.href = "/cs/assets"; }}
                >
                  <div className="wpx-35 hpx-35 rounded bg-purple-light text-purple d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf1b3"}</div>
                  <span className="fw-bold text-dark text-14">{t("view_my_assets")}</span>
                </button>
                <button
                  className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover"
                  onClick={() => { window.location.href = "/cs/service-history"; }}
                >
                  <div className="wpx-35 hpx-35 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf1da"}</div>
                  <span className="fw-bold text-dark text-14">{t("service_history")}</span>
                </button>
                <button className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover">
                  <div className="wpx-35 hpx-35 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf095"}</div>
                  <span className="fw-bold text-dark text-14">{t("contact_support")}</span>
                </button>
              </div>

              {warranty_alert.count > 0 && (
                <div className="card border-0 rounded-4 p-3 shadow-sm" style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a !important' }}>
                  <div className="d-flex align-items-start">
                    <span className="icon text-warning me-2 text-18">{"\uf071"}</span>
                    <div>
                      <h6 className="fw-bold text-dark mb-1 text-14">{t("warranty_expiring")}</h6>
                      <div className="text-secondary text-12 mb-2">{this.warrantyMessage()}</div>
                      <a href="/cs/assets" className="text-warning text-decoration-none fw-bold text-12">{t("view_details")}</a>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
